export const environment = {
  production: true,
  env: 'arb',
  url: 'https://arb.zomma.pro/',
  apiUrl: 'https://arb-api.zomma.pro/',
  wsUrl: 'wss://arb-api.zomma.pro/cable',
  tasks: {
    twitterTaskId: 1,
    discordTaskId: 2,
    compensationTaskId: 3
  },
  borrowAsset: 'GHO',
  rewardAssets: ['0x18248226c16bf76c032817854e7c83a2113b4f06'],
  features: {
    faucet: false,
    blackScholesLookup: false,
    apiSpot: true,
    signedData: true,
    multiTrade: false,
    ivAdjust: false,
    checkCountry: true,
    paymaster: false,
    bridges: false,
    rewards: true,
    referrals: true,
    retired: false,
    vault: false,
    skipTry: false,
    feeData: true
  },
  paymasters: [] as any[],
  retired: {
    vaults: [] as any[],
    pools: [] as any[]
  },
  betaRetired: {
    vaults: [] as any[],
    pools: [] as any[]
  },
  arbRetired: {
    zToken: {
      address: '0x452610bb258c143b5f26687286ae5e59ec69c267',
      decimals: 6
    },
    vaults: [
      {
        name: 'BTC-USDC Trade Account',
        address: '0xf6f0060b2531441d8ed9c5d4bb774012394a68c5'
      },
      {
        name: 'ETH-USDC Trade Account',
        address: '0x78a1490060dde521cce1445df0e040f26dbf6852'
      }
    ],
    pools: [
      {
        name: 'BTC-USDC Pool',
        address: '0x275376e25e068c894d0df5cc9a3d1893d94e9f4a',
      },
      {
        name: 'ETH-USDC Pool',
        address: '0xa9deb981b735ec0525c8d4c959267429fdd82347',
      }
    ]
  },
  networks: [
    {
      name: 'Arbitrum',
      icon: '/retired-arbitrum/assets/images/icons/asset_arbitrum_20.svg',
      faucet: false,
      contracts: {
        optionPricer: '0x4acee9ecfec905579baf8156fd3e0ec0c0eab4d6',
        tokenReward: '0xfda7907a2c0f87f57e5a0a1b238d468d55868936',
        zy: '0x4502ca3f34f9a495e2df81b95d1bf1965c3c47e6'
      },
      ztokens: {
        '0x452610bb258c143b5f26687286ae5e59ec69c267': '0xaf88d065e77c8cc2239327c5edb3a432268e5831'
      },
      params: {
        chainId: '0xa4b1',
        chainName: 'Arbitrum',
        nativeCurrency: {
          name: 'ETH',
          symbol: 'ETH',
          decimals: 18
        },
        rpcUrls: [
          'https://arb1.arbitrum.io/rpc'
        ],
        blockExplorerUrls: ['https://arbiscan.io/']
      }
    }
  ]
};
